import apiClient from './client'

export const favoritesApi = {
  getFavorites: async () => {
    const response = await apiClient.get('/favorites')
    return response.data
  },

  addFavorite: async (type, itemId) => {
    const response = await apiClient.post('/favorites', { 
      type: type, // 'course', 'lecture', or 'instructor'
      item_id: itemId 
    })
    return response.data
  },

  removeFavorite: async (id) => {
    const response = await apiClient.delete(`/favorites/${id}`)
    return response.data
  },

  checkFavorite: async (type, itemId) => {
    const response = await apiClient.get('/favorites/check', { 
      params: { 
        type: type, // 'course', 'lecture', or 'instructor'
        item_id: itemId 
      } 
    })
    return response.data
  },
}

